export default "https://cdn-static.gokick.com/assets/b96dd49a95534624185e45ca053b90dd739d9b4e/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";